module.exports = __webpack_public_path__ + "img/very_rare_decor_image.77ac37bc.png";